import React, { useState } from "react";
import { useSearchParams, useNavigate } from 'react-router-dom';
import { confirmPasswordReset } from "firebase/auth";
import { auth } from "../config/firebase";
import { KeySquare, Loader2 } from "lucide-react";

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const oobCode = searchParams.get('oobCode');
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleReset = async () => {
    if (!newPassword || newPassword.length < 6) return alert("密碼太短");
    setLoading(true);
    try {
      await confirmPasswordReset(auth, oobCode, newPassword);
      alert("✅ 密碼重設成功，請重新登入");
      navigate("/login");
    } catch (e) {
      alert("重設失敗，連結可能已過期");
    } finally {
      setLoading(false);
    }
  };

  if (!oobCode) return <div className="p-10 text-center">無效的連結</div>;

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-sm">
        <h2 className="text-xl font-black mb-4 flex items-center gap-2"><KeySquare className="text-orange-500"/> 重設新密碼</h2>
        <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="輸入新密碼" className="w-full p-3 border rounded-xl mb-4"/>
        <button onClick={handleReset} disabled={loading} className="w-full bg-slate-900 text-white p-3 rounded-xl font-bold">
          {loading ? <Loader2 className="animate-spin mx-auto"/> : "確認重設"}
        </button>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
